import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Controller, useFormContext } from 'react-hook-form';
import { Column } from 'seagull';
import { useAccountingCustomers } from '~/hooks/reactQuery/queries/useAccountingCustomers';
import { useIntegrationsSummary } from '~/hooks/reactQuery/queries/useIntegrationsSummary';
import { useLocaleKeys } from '~/i18n';
import AccountingCustomerDropdown from '~/integrations/Accounting/AccountingCustomerDropdown/AccountingCustomerDropdown';
import { selectors } from '~/store/state-selectors';
import { useStore } from '~/store/store-context';
import { Accounting } from '~/types/api.model';
import { contactFormTextsPath } from './ContactForm';
export function ContactAccountingMapping(param) {
    let { namePrefix } = param;
    const { control } = useFormContext();
    const { t } = useLocaleKeys(contactFormTextsPath);
    const isLinkedToQbo = useStore(selectors.integration.isLinkedToQbo);
    const isLinkedToXero = useStore(selectors.integration.isLinkedToXero);
    useIntegrationsSummary({
        enabled: isLinkedToQbo || isLinkedToXero,
        refreshOnHookMount: true
    });
    const { customers: qboCustomers, isLoading: qboLoading } = useAccountingCustomers(Accounting.QBO, {
        enabled: isLinkedToQbo,
        refreshOnHookMount: true
    });
    const { customers: xeroCustomers, isLoading: xeroLoading } = useAccountingCustomers(Accounting.Xero, {
        enabled: isLinkedToXero,
        refreshOnHookMount: true
    });
    if (!isLinkedToQbo && !isLinkedToXero) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(Column, {
        gap: 16,
        alignItems: "stretch",
        children: [
            isLinkedToQbo && /*#__PURE__*/ _jsx(Controller, {
                control: control,
                name: "".concat(namePrefix, ".qbo"),
                render: (param)=>{
                    let { field } = param;
                    return /*#__PURE__*/ _jsx(AccountingCustomerDropdown, {
                        accounting: Accounting.QBO,
                        value: field.value,
                        onChange: (option)=>field.onChange(option),
                        accountingCustomers: qboCustomers,
                        loading: qboLoading,
                        textFieldProps: {
                            bi: {
                                name: 'qbo_customer_mapping'
                            },
                            label: t.qboMappingLabel()
                        }
                    });
                }
            }),
            isLinkedToXero && /*#__PURE__*/ _jsx(Controller, {
                control: control,
                name: "".concat(namePrefix, ".xero"),
                render: (param)=>{
                    let { field } = param;
                    return /*#__PURE__*/ _jsx(AccountingCustomerDropdown, {
                        accounting: Accounting.Xero,
                        value: field.value,
                        onChange: (option)=>field.onChange(option),
                        accountingCustomers: xeroCustomers,
                        loading: xeroLoading,
                        textFieldProps: {
                            bi: {
                                name: 'xero_customer_mapping'
                            },
                            label: t.xeroMappingLabel()
                        }
                    });
                }
            })
        ]
    });
}
